/* MV124 (v34) — v33 plus TWO sort buttons, nothing else:
   "High Score" and "Low Score" after "Low Sold %": the Deals List ordered by
   the JEV score (api/deals.php, sort=score_high / score_low; deals without a
   score last). They are a third group beside price and sold: one of the two
   at a time, combinable with one price, one sold, Hot Deals and the
   categories. v33 is still on disk: point index.html back at it to roll back. */
/* MV121 (v33) — v32 plus ONE change, nothing else:
   THE HOT DEAL POPUP says "7 clicks in the last 12 hours" under the
   12-hour rules. v32 printed every window in minutes, which for the new
   12-hour window read "7 clicks in the last 720 minutes". A window of two
   hours or more is now written in hours; the 5-minute window of the MV119
   rules still reads exactly as before.
   v32 is still on disk: point index.html back at it to roll back. */
/* MV119 (v32) — v31 plus three changes, nothing else:
   1. ITS OWN COPY OF THE DEALS LIST NO LONGER GOES TO THE NETWORK.
      start() runs while the deferred scripts are still executing, so its
      loadDeals() fired BEFORE mavely-dealsflow (loaded later) had wrapped
      fetch — and downloaded every deal of every store a second time
      (4.3 MB of JSON on a 6,500-deal library, 555 KB over the wire) at the
      busiest moment of the page load. It now waits for DOMContentLoaded,
      which fires after every deferred script, so dealsflow answers it
      from the list it already holds. Without dealsflow it behaves as v31.
   2. THE HOT CARD EFFECTS ARE COMPOSITED. The glow animated box-shadow and
      the shine animated background-position — both repaint on the main
      thread every frame, forever, for every hot card on screen ("Avoid
      non-composited animations"). Same look, now opacity (glow) and
      transform (shine), which the GPU animates on its own.
   3. THE POPUP TEXT follows the MV119 rules (clicks in the last 5
      minutes when there are some, otherwise the total).
   v31 is still on disk: point index.html back at it to roll back. */
/* MV115 (v31) — v30 plus three performance/stability changes, nothing else:
   the sort bar is inserted before first paint (layout shift), text-only DOM
   changes are batched (main-thread work), findConfigPanelHost() no longer
   reads the text of every element. Its own copy of the deals list is now
   served from memory by mavely-dealsflow.v1.js (no second download). */
    function isSeeDeal(node) {
        if (!node || node.nodeType !== 1) return false;
        var tag = node.tagName;
        if (tag !== 'BUTTON' && tag !== 'A' &&
            !(tag === 'DIV' && node.getAttribute('role') === 'button')) return false;

        /* -------------------------------------------------------------------
           THE TEXT MUST BE THE LABEL, NOT MERELY CONTAIN IT
           -------------------------------------------------------------------
           This used to return true for anything whose text CONTAINED "See
           Deal". A card wrapped in a <button> or an <a> contains its own See
           Deal label, comes earlier in document order, and so matched first.

           Harmless while this was only used to identify the card. Not harmless
           once it was used to find the button's PARENT: that parent became the
           card's whole content row, and padding it pushed the image, the title
           and the button all down and put the badge across the middle of the
           card — your.png exactly.

           So: the trimmed text must BE the label, and the control must not
           contain a deal image, which no real button does and every card
           wrapper does.
           ------------------------------------------------------------------- */
        if (node.querySelector && node.querySelector('img[alt="Deal product"]')) return false;

        var t = (node.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
        if (t.length > 24) return false;                 // a wrapper, not a label
        return t === 'SEE DEAL' || t.indexOf('SEE DEAL') !== -1
            || t.indexOf('شاهد') !== -1;
    }

/* ===========================================================================
   MAVELY DEALS LAYER  v25
   ---------------------------------------------------------------------------
   Items 1, 3, 5 and 7:

       9  HOT DEALS — badge, popup and filter                (hotdeal.png)
       1  price / old price / discount on Deals List cards   (my_sold.png)
       3  "Add Price" checkbox in the landing page options   (soldlanding_page.png)
       5  High Price / Low Price / High Sold % / Low Sold %  filters
       7  green NEW badge on the deal image                  (new.png)

   DELIBERATELY A SEPARATE FILE from mavely-ui.*.js. These four touch DOM that
   React owns, which is riskier than the Work Mode layer; keeping them apart
   means a fault here cannot take Work Mode down with it, and either file can
   be removed on its own.

   ---------------------------------------------------------------------------
   THE ONE RULE THAT MAKES THIS SAFE: ONLY EVER appendChild
   ---------------------------------------------------------------------------
   React reconciles by holding references to the nodes it created. Inserting a
   node BEFORE those, or wrapping them, moves them out from under it and can
   throw NotFoundError on the next render. Appending AFTER them does not:
   React inserts relative to its own refs and simply ignores a trailing node
   it does not know about.

   So every injection here is an appendChild, and where the design needs the
   new element to sit earlier — the "Add Price" checkbox goes in FRONT of
   "Multi Deals", the filters go BELOW Download ZIP — CSS `order` moves it
   visually. Nothing is ever inserted, moved, wrapped or removed.

   ---------------------------------------------------------------------------
   HOW A CARD IS MATCHED TO ITS DEAL
   ---------------------------------------------------------------------------
   The card renders <img src={t.image_path}>, and image_path is exactly what
   /api/deals returns for that deal. So the image src is a reliable join key —
   no text matching, no DOM position guessing, no reliance on order.
   =========================================================================== */

(function () {
    'use strict';

    if (window.__MAVELY_DEALS_V25__) return;
    window.__MAVELY_DEALS_V25__ = true;
    window.__MAVELY_DEALS_V24__ = true;  // stops an older layer running as well
    window.__MAVELY_DEALS_V23__ = true;
    window.__MAVELY_DEALS_V22__ = true;
    window.__MAVELY_DEALS_V21__ = true;
    window.__MAVELY_DEALS_V20__ = true;
    window.__MAVELY_DEALS_V19__ = true;
    window.__MAVELY_DEALS_V18__ = true;
    window.__MAVELY_DEALS_V17__ = true;
    window.__MAVELY_DEALS_V16__ = true;
    window.__MAVELY_DEALS_V15__ = true;
    window.__MAVELY_DEALS_V14__ = true;
    window.__MAVELY_DEALS_V13__ = true;
    window.__MAVELY_DEALS_V12__ = true;
    window.__MAVELY_DEALS_V11__ = true;
    window.__MAVELY_DEALS_V10__ = true;
    window.__MAVELY_DEALS_V9__ = true;
    window.__MAVELY_DEALS_V8__ = true;

    /* =======================================================================
       WHY THIS FILE IS v10 AND NOT ANOTHER EDIT TO v9
       =======================================================================
       /assets/ is served with

           Cache-Control: public, max-age=31536000, immutable

       (.htaccess, the MV_IMMUTABLE rule). "immutable" is a promise to the
       browser that the file at this URL will NEVER change, so once it has a
       copy it will not ask again for a year — no reload, no Ctrl+F5, nothing.

       Three rounds of fixes were made to mavely-deals.v9.js under the SAME
       filename. Every one of them was uploaded correctly and none of them ever
       reached the browser: it was still running the first copy it cached. The
       console proved it — "[mavely-deals] v9 ready" reported from line 767,
       while the file on disk had that line at 976.

       mavely-switch went v4 -> v5 -> v6 -> v7 across the same rounds and worked
       every time, for exactly this reason.

       So: any change to this file means a new filename and a matching change in
       index.html. Never edit an /assets/ file in place.
       ======================================================================= */

    /* -----------------------------------------------------------------------
       ITEM 9 — HOT DEALS
       -----------------------------------------------------------------------
       A deal is hot when a shortlink pointing at the same product has taken
       more than 20 clicks in the last 2 days. The whole judgement is made on
       the server (api/_hot_lib.php) — this file only draws what it is told,
       because the browser has no access to the Link Ledger and the deal list
       is paginated here, so anything decided in the page would only ever see
       the rows currently on screen.

       api/deals returns is_hot and hot_clicks on every deal. If those fields
       are absent — an older backend, or _hot_lib.php deleted — nothing is
       drawn and every other feature carries on untouched.
       --------------------------------------------------------------------- */
    var HOT_ICON = '/assets/hot-deals.png';   // kept for the popup's small mark

    /* =======================================================================
       THE NEW BADGE — drawn here, not loaded
       =======================================================================
       A compact pill rather than a starburst. The starburst was 265x204: wide
       AND tall, which is why it could never share a line with anything and
       spent ten revisions colliding with the See Deal button. A pill is 96x24
       and fits in the gap above the card, where nothing else lives.

       It is inline SVG, which means: no file to cache-bust, no 422 from the
       host, crisp at any zoom, and it cannot be left unstyled the way an <img>
       can when a stylesheet fails to load.

       Each instance needs its own gradient id — SVG ids are global to the
       document, and a hundred cards sharing one id makes every badge after the
       first take its fill from whichever copy happened to render last.
       ======================================================================= */
    var hotIdSeq = 0;

    function buildBadgeSvg() {
        var id = 'mvhot' + (++hotIdSeq);
        return ''
        + '<svg class="mv-hotsvg" width="96" height="24" viewBox="0 0 96 24" '
        +      'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'
        +   '<defs>'
        +     '<linearGradient id="' + id + 'g" x1="0" y1="0" x2="0" y2="1">'
        +       '<stop offset="0" stop-color="#FF9A22"/>'
        +       '<stop offset="0.55" stop-color="#F4451F"/>'
        +       '<stop offset="1" stop-color="#D81E2C"/>'
        +     '</linearGradient>'
        +   '</defs>'
        +   '<rect x="1" y="1" width="94" height="22" rx="11" fill="url(#' + id + 'g)" '
        +        'stroke="#FFFFFF" stroke-width="1.6"/>'
        // flame
        +   '<path d="M13.6 5.2c1.9 1.9 1.1 3.4.5 4.4-.5.9-.2 2 .8 2.3.9.3 1.8-.3 1.9-1.3'
        +          '.9 1 1.4 2.2 1.4 3.4 0 2.7-2.2 4.9-4.9 4.9S8.4 16.7 8.4 14c0-3.1 2.2-4.6 3.3-6.3'
        +          '.6-.9 1-1.8 1.9-2.5z" fill="#FFD75E"/>'
        +   '<text x="55" y="16.4" text-anchor="middle" '
        +        'font-family="Inter, Segoe UI, Helvetica, Arial, sans-serif" '
        +        'font-size="10.5" font-weight="800" letter-spacing="1.1" fill="#FFFFFF">HOT DEAL</text>'
        + '</svg>';
    }

    /* The artwork is 265x204, so height follows width at 0.77. RESERVE is the
       vertical space the action column is padded by to hold the badge plus a
       gap — the badge can then never land on the See Deal button, because the
       button starts below the padding. */
    var BADGE_W = 76;
    var BADGE_H = Math.round(BADGE_W * 204 / 265);   // 59
    var BADGE_GAP = 7;
    var RESERVE = BADGE_H + BADGE_GAP;               // 66

    /* How many deals to badge in the browser when the server marked none.
       0 disables the safety net and leaves the server solely in charge.

       -----------------------------------------------------------------------
       MV113.3 — WAS 8, NOW 0, AND THAT IS THE WHOLE OF THIS FILE'S CHANGE.
       -----------------------------------------------------------------------
       hotdeal.png: brand new short links, with zero clicks, wearing a HOT DEAL
       badge. This was it — not the server.

       The safety net below fires whenever the response contains NOTHING hot,
       and badges the first FORCE_HOT deals of that response. It was written
       for a different situation: back when api/_hot_lib.php seeded eight
       handpicked deals, "nothing hot" could only mean the library had failed
       to upload, so guessing was better than a feature that looked broken.

       That is no longer true. Hot Deals is now click-driven only — a product
       goes hot on its seventh click in the window and not before — so "nothing
       hot" is the CORRECT and expected answer on a quiet day, and there is
       nothing to rescue. Worse, the first deals in the response are the newest
       ones, which is precisely why the freshly shortened links in the
       screenshot were the ones being badged.

       The code below is untouched and still works; it simply never runs,
       because the loop is bounded by this number. Put

           var FORCE_HOT = 8;

       back to restore the old behaviour exactly.
       --------------------------------------------------------------------- */
    var FORCE_HOT = 0;

    var SORT_COOKIE = 'mv_deal_sort';
    var PRICE_KEY   = 'mv_add_price';

    var dealsByImage = {};      // image_path -> deal
    var fetchedAt    = 0;
    var fetching     = false;

    /* ---------------------------------------------------------------------
       DATA
       --------------------------------------------------------------------- */

    function loadDeals(cb) {
        var now = Date.now();
        if (now - fetchedAt < 60000 && Object.keys(dealsByImage).length) { if (cb) cb(); return; }
        if (fetching) return;
        fetching = true;

        /* Same endpoint the page already uses, so this is a cache hit far more
           often than not. source=deals keeps it consistent with the tab. */
        fetch('/api/deals?source=deals', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
                fetching = false;
                if (!j || !j.success || !Array.isArray(j.deals)) return;
                /* ------------------------------------------------------------
                   THE SAFETY NET
                   ------------------------------------------------------------
                   The server marks the handpicked deals (api/_hot_lib.php) and
                   also lifts them to the top of the list, which is the proper
                   way round and the only way they can lead page 1.

                   But if the server marks NOTHING — the library did not upload,
                   HOT_SEED_COUNT is 0, an older api/deals.php is still in place
                   — then no badge is drawn anywhere and the feature looks
                   broken, which is exactly what kept happening.

                   So: if nothing arrived hot, the first FORCE_HOT deals of the
                   response are marked here instead. The FIRST ones, not a
                   random pick, because without the server's reordering only the
                   deals at the top of the response are on page 1 — and a badge
                   nobody can see is no better than no badge.

                   This is a fallback, not the design. When it fires it says so
                   in the console, because it means the server side needs
                   looking at.
                   ------------------------------------------------------------ */
                if (j.hotStyle) hotLook.style = String(j.hotStyle);
                if (j.hotImage !== undefined) hotLook.image = String(j.hotImage || '');
                if (j.hotEffects !== undefined) hotLook.effects = !!j.hotEffects;
                if (j.hotRules && j.hotRules.windowSec) hotRules.windowSec = +j.hotRules.windowSec || 300;   // MV119

                var nHot = 0;
                for (var q = 0; q < j.deals.length; q++) {
                    if (j.deals[q] && j.deals[q].is_hot) nHot++;
                }

                var forced = 0;
                if (!nHot && j.deals.length && FORCE_HOT > 0) {
                    var lim = Math.min(FORCE_HOT, j.deals.length);
                    for (var z = 0; z < lim; z++) {
                        if (!j.deals[z]) continue;
                        j.deals[z].is_hot     = true;
                        j.deals[z].hot_seeded = true;
                        j.deals[z].hot_clicks = 0;
                        forced++;
                    }
                    nHot = forced;
                }

                if (window.console && console.info) {
                    console.info('[mavely-deals] ' + j.deals.length + ' deals, ' + nHot + ' hot'
                        + (j.hotSeeded ? ' (' + j.hotSeeded + ' handpicked by the server)' : '')
                        + (forced ? ' (' + forced + ' marked in the browser — the server marked none,'
                                  + ' so check api/_hot_lib.php uploaded)' : ''));
                }

                var map = {};
                for (var i = 0; i < j.deals.length; i++) {
                    var d = j.deals[i];
                    if (d && d.image_path) map[d.image_path] = d;
                }
                dealsByImage = map;
                fetchedAt = Date.now();
                if (cb) cb();
                decorate();
            })
            .catch(function () { fetching = false; });
    }

    /* ---------------------------------------------------------------------
       ITEMS 1 + 7 — price row and NEW badge on each card
       --------------------------------------------------------------------- */

    function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text !== undefined && text !== null) n.textContent = text;
        return n;
    }

    /* ---------------------------------------------------------------------
       ITEM 9 — the HOT DEALS badge and its popup
       ---------------------------------------------------------------------
       The badge belongs in the card's RIGHT COLUMN, under the green See Deal
       button (hotdeal.png), not on the image like the NEW and discount badges.
       So it needs the card root rather than the image box — found by walking up
       from the image until an ancestor contains the See Deal control.

       Appended, never inserted, per the rule at the top of this file. CSS
       places it under the button.
       --------------------------------------------------------------------- */

    /* -----------------------------------------------------------------------
       THE BADGE IS STYLED INLINE, NOT ONLY BY THE STYLESHEET
       -----------------------------------------------------------------------
       Your console already reports

           [mavely-ui] mavely-ui.v9.css did not load

       so a stylesheet in /assets/ failing on your host is not hypothetical, it
       is happening. If mavely-deals.v10.css goes the same way, an unstyled
       <button><img></button> is a browser-default button wrapping a 265x204
       image — either enormous or, inside a flex row with no flex:0 0 auto,
       squeezed to nothing.

       So every rule the badge cannot do without is also written onto the
       element, with priority "important" so nothing in the page can drop it.
       The stylesheet still does hover, transitions and the popup; those are
       nice to have. This is the part that decides whether the icon is visible
       at all.
       ----------------------------------------------------------------------- */
    /** Write styles onto an element with priority, so nothing can drop them. */
    function styleInline(node, rules) {
        if (!node || !node.style) return;
        for (var k in rules) {
            if (rules.hasOwnProperty(k)) node.style.setProperty(k, rules[k], 'important');
        }
    }

    /* Does the browser understand logical inset properties? Every browser since
       2021 does; the physical fallback below is for anything older. */
    var HAS_LOGICAL = (function () {
        try { return !!(window.CSS && CSS.supports && CSS.supports('inset-inline-end', '8px')); }
        catch (e) { return false; }
    })();

    /* -----------------------------------------------------------------------
       HOW THE BADGE GETS ITS OWN SPACE — THE PART THAT KEPT GOING WRONG
       -----------------------------------------------------------------------
       Two approaches have now failed on your layout:

         absolute      takes part in no layout, so the card never grew and the
                       See Deal button came down on top of the badge
         flex in flow  relies on the action column being a growable flex column.
                       On your cards it is not growing, so the badge and the
                       button ended up sharing the same space anyway

       Neither asked the column to make room; both hoped it would.

       This asks. The action column is given padding-top equal to the badge
       plus a gap, and the badge is placed absolutely inside that reserved
       strip. The button starts BELOW the padding, so the two cannot overlap
       whatever the column's display happens to be — flex, block, grid, fixed
       height, anything. The column is taller by exactly the reserve, so the
       card grows with it, which is what makes hot.png's cards taller than the
       ordinary ones.

       The badge is centred with left:50% and translateX(-50%), which is
       direction-neutral: Arabic needs no separate case, because the centre of
       a box is in the same place in both directions.
       ----------------------------------------------------------------------- */

    /* -----------------------------------------------------------------------
       PLACED AGAINST THE BUTTON, MEASURED — NOT GUESSED
       -----------------------------------------------------------------------
       deals.png shows the badge sitting directly above the See Deal button at
       the card's top-right, overhanging the corner by a few pixels. Nothing
       else about the card changes.

       Three earlier attempts each changed the card to make room and each broke
       something: absolute positioning let the button land on the badge, flex
       order needed a column that does not exist, and padding-top landed on the
       card's whole content row and pushed the entire layout down.

       So nothing is changed to make room. The badge is positioned against the
       card and its top is COMPUTED from where the button actually is:

           top = button's top  -  badge height  -  gap

       If the button sits high in a short card that comes out negative, and the
       badge simply overhangs the card's top edge — which is the overlap in the
       reference. It can never cover the button, because its bottom edge is
       placed a fixed gap above the button's top edge, whatever the card's
       height or the button's alignment.

       Horizontally it is centred on the button, so it needs no left/right rule
       and mirrors in Arabic for free.
       ----------------------------------------------------------------------- */

    /** Undo anything a previous version reserved on this column. */
    function releaseSpace(col) {
        if (!col || !col.hasAttribute || !col.hasAttribute('data-mv-pad0')) return;
        var base = parseFloat(col.getAttribute('data-mv-pad0')) || 0;
        if (base > 0) col.style.setProperty('padding-top', base + 'px', 'important');
        else col.style.removeProperty('padding-top');
        col.removeAttribute('data-mv-pad0');
    }

    var BADGE_TOP = -4;                       // fallback corner, if rows cannot be read

    /* -----------------------------------------------------------------------
       THE TWO-LINE LAYOUT
       -----------------------------------------------------------------------
       The card's middle area is two lines: the title on the first, the deal
       link on the second. The right-hand side gets one element per line —
       the badge beside the title, the See Deal button beside the link.

       That removes the problem every previous version was fighting. The badge
       and the button were competing for the same vertical space beside a
       two-line block; giving them a line each means there is nothing left to
       collide over, and the card does not need to grow at all.

       THE SIZE FOLLOWS FROM IT. A badge on the title line can only be about as
       tall as that line, plus a little overhang. So the width is computed from
       the measured line rather than fixed: as large as the line allows, capped
       at 76px so it never gets silly on a tall card and never below 48px on a
       cramped one. On a typical card that lands around 56-64px.
       ----------------------------------------------------------------------- */

    /* =======================================================================
       THE BUTTON IS NOT TOUCHED ANY MORE — WHICH IS WHY IT IS STABLE
       =======================================================================
       Versions 15 to 21 moved the See Deal button to make room beside it:
       margin, then flex order, then padding, then a transform. Each one had to
       MEASURE the button, and each measurement happened while the list was
       re-rendering underneath it — so the button was read in one place, moved,
       read again somewhere else, and moved again. That is the drifting you saw:
       sometimes up, sometimes down, never settling.

       Putting the badge in the middle of the card removes the reason to move
       it. Nothing competes for the space beside the button, so the button can
       simply stay where your card's own CSS puts it. No measuring, no
       transform, no margin, nothing to drift.

       releaseButton() is kept and still called, so a card that a previous
       version already pushed around is put back the moment this one runs.
       ======================================================================= */

    /** Undo anything an earlier version did to a button. */
    function releaseButton(btn) {
        if (!btn || !btn.hasAttribute) return;
        if (btn.hasAttribute('data-mv-tf0')) {
            var tf = btn.getAttribute('data-mv-tf0') || '';
            if (tf) btn.style.setProperty('transform', tf); else btn.style.removeProperty('transform');
            btn.removeAttribute('data-mv-tf0');
        }
        if (btn.hasAttribute('data-mv-mt0')) {
            var base = parseFloat(btn.getAttribute('data-mv-mt0')) || 0;
            if (base > 0) btn.style.setProperty('margin-top', base + 'px', 'important');
            else btn.style.removeProperty('margin-top');
            btn.removeAttribute('data-mv-mt0');
        }
        if (btn.hasAttribute('data-mv-as0')) {
            var as = btn.getAttribute('data-mv-as0') || '';
            if (as) btn.style.setProperty('align-self', as); else btn.style.removeProperty('align-self');
            btn.removeAttribute('data-mv-as0');
        }
    }

    /** Undo anything an earlier version reserved on a column. */
    function releaseSpace(col) {
        if (!col || !col.hasAttribute || !col.hasAttribute('data-mv-pad0')) return;
        var base = parseFloat(col.getAttribute('data-mv-pad0')) || 0;
        if (base > 0) col.style.setProperty('padding-top', base + 'px', 'important');
        else col.style.removeProperty('padding-top');
        col.removeAttribute('data-mv-pad0');
    }

    /**
     * Position the badge: centred on the card, straddling its top edge.
     *
     * No measurement of anything else on the card, so there is nothing to
     * disagree with and nothing to re-measure. Centring is also
     * direction-neutral — the centre of a box is the centre in Arabic too.
     */
    function applyHotLayout(card, btn, badge, im) {
        releaseButton(btn);            // put back whatever an older version did
        if (!badge) return;
        /* INSIDE the card now, not straddling its edge. The pill is 96x24 and
           the See Deal button sits well below the top on these cards, so the
           two fit without the button being moved — which is what kept it
           drifting in every version up to v21. */
        badge.style.setProperty('position', 'absolute', 'important');
        badge.style.setProperty('top', '8px', 'important');
        badge.style.setProperty('left', 'auto', 'important');
        badge.style.setProperty('transform', 'none', 'important');

        var logicalTook = false;
        if (HAS_LOGICAL) {
            badge.style.setProperty('inset-inline-end', '10px', 'important');
            badge.style.setProperty('inset-inline-start', 'auto', 'important');
            logicalTook = (badge.style.getPropertyValue('inset-inline-end') !== '');
        }
        if (logicalTook) {
            badge.style.removeProperty('right');
        } else {
            var rtl = isRtl(card);
            badge.style.setProperty(rtl ? 'left' : 'right', '10px', 'important');
            badge.style.setProperty(rtl ? 'right' : 'left', 'auto', 'important');
        }
    }

    function styleBadge(badge, im, card) {
        var b = {
            'position': 'absolute',
            'top': '8px',
            'transform': 'none',
            'z-index': '7',
            'display': 'block',
            'margin': '0',
            'padding': '0',
            'border': '0',
            'background': 'none',
            'cursor': 'pointer',
            'line-height': '0',
            'overflow': 'visible',
            'opacity': '1',
            'visibility': 'visible',
            'pointer-events': 'auto',
            'width': 'auto',
            'height': 'auto',
            'min-width': '0',
            'max-width': 'none',
            'filter': 'drop-shadow(0 2px 4px rgba(0,0,0,.28))'
        };
        for (var k in b) { if (b.hasOwnProperty(k)) badge.style.setProperty(k, b[k], 'important'); }

        /* The SVG carries its own width and height attributes, so it needs no
           sizing rules and cannot be left enormous by a stylesheet that failed
           to load — which is what happened to the 265x204 PNG. */
        var svg = badge.querySelector('svg');
        if (svg) {
            svg.style.setProperty('display', 'block', 'important');
            svg.style.setProperty('width', '96px', 'important');
            svg.style.setProperty('height', '24px', 'important');
            svg.style.setProperty('pointer-events', 'none', 'important');
        }
    }

    /** Did our stylesheet actually arrive? Reported once, for diagnosis. */
    function dealsCssLoaded() {
        try {
            var probe = document.createElement('div');
            probe.className = 'mv-hotbadge';
            probe.style.cssText = '';
            document.body.appendChild(probe);
            var ok = window.getComputedStyle(probe).cursor === 'pointer';
            probe.remove();
            return ok;
        } catch (e) { return true; }   // cannot tell: assume fine, inline styles cover us
    }

    function isSeeDeal(node) {
        if (!node || node.nodeType !== 1) return false;
        var tag = node.tagName;
        // div[role="button"] counts too — it is queried for a few lines below,
        // and rejecting it here made that query pointless.
        if (tag !== 'BUTTON' && tag !== 'A' &&
            !(tag === 'DIV' && node.getAttribute('role') === 'button')) return false;
        var t = (node.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
        /* CONTAINS, not starts-with. The real button reads "👁 See Deal" — the
           eye is part of the text, so a starts-with test never matched and the
           right-hand column was never found, which sent every badge down the
           pinned path. */
        return t.indexOf('SEE DEAL') !== -1 || t.indexOf('شاهد') !== -1;
    }

    /*  WHERE THE BADGE GOES  — and why the first attempt did not show up.
        ------------------------------------------------------------------
        It used to be appended to the CARD, which is a flex ROW: image, then
        the title block, then the right-hand column with See Deal in it.
        Appending there made the badge a fourth item in that row, so it was
        squeezed into whatever space was left — in practice none, which is why
        nothing appeared on screen even though the element was in the DOM.

        hotdeal.png shows it inside the right-hand COLUMN, directly under the
        See Deal button. So that column is the target: find the See Deal
        control, and hand back its parent. Appending to a column stacks
        underneath, which is exactly the wanted layout and needs no absolute
        positioning.

        Returns { host, card } — the card is still wanted for the marker
        attribute, so a re-render cannot double up the badge. */
    /* -----------------------------------------------------------------------
       THE BADGE IS PINNED TO THE CARD. ALWAYS.
       -----------------------------------------------------------------------
       Up to v12 it was placed INSIDE the action column, in flow, above the
       See Deal button. That needed three fragile things to hold at once: the
       button had to be found, the column had to be a flex column (and was
       forced into one when it was not), and the badge had to fit the column's
       width. In Arabic that column is narrow, so a 60px badge overflowed it
       and spilled outside the card — the "with refresh" panel of arab.png.

       Now it is absolutely positioned against the CARD, at the top of the side
       the action column is on. That is the same place hot.png shows it, and it
       cannot push the button, cannot be squeezed by a flex row, and cannot
       overflow a narrow column, because it takes part in no layout at all.

       The See Deal button is no longer needed to place it, which removes every
       failure that started with "the button could not be found".
       ----------------------------------------------------------------------- */
    function findBadgeHost(img) {
        /* ------------------------------------------------------------------
           THE WHITE CARD, NOT THE ROW AROUND IT
           ------------------------------------------------------------------
           Climb from the image collecting every ancestor that still holds
           exactly one deal image. The outermost of those is the ROW — the
           trash button plus the card — and pinning to the row is what pushed
           the badge onto the card's border in English and onto the trash
           button in Arabic, because the row is wider than the card on the side
           the trash sits.

           So of the candidates, take the INNERMOST one that also contains the
           See Deal control. That is the white card exactly: the trash button
           is outside it, the image and the button are both inside it.

           Only if no See Deal control can be found anywhere does it fall back
           to the outermost candidate, which is the old behaviour and still
           better than nothing.
           ------------------------------------------------------------------ */
        var candidates = [];
        var n = img;
        for (var up = 0; up < 10 && n.parentElement; up++) {
            n = n.parentElement;
            if (n.querySelectorAll('img[alt="Deal product"]').length !== 1) break;
            candidates.push(n);
        }
        if (!candidates.length) return null;

        /* The white card is the INNERMOST candidate that contains the See Deal
           button — the trash button is outside it, the image and the button are
           both inside it. The outermost candidate is the row, and pinning to
           the row put the badge over the trash button in Arabic. */
        for (var i = 0; i < candidates.length; i++) {
            var all = candidates[i].querySelectorAll('button, a, div[role="button"]');
            for (var j = 0; j < all.length; j++) {
                if (isSeeDeal(all[j])) {
                    return { host: candidates[i], card: candidates[i], btn: all[j] };
                }
            }
        }

        var last = candidates[candidates.length - 1];
        return { host: last, card: last, btn: null };
    }

    /** Is this card laid out right-to-left? */
    function isRtl(node) {
        try {
            if (window.getComputedStyle(node).direction === 'rtl') return true;
        } catch (e) {}
        var d = (document.documentElement.getAttribute('dir') || '').toLowerCase();
        return d === 'rtl';
    }

    var popupEl = null;

    function closeHotPopup() {
        if (popupEl && popupEl.parentElement) popupEl.parentElement.removeChild(popupEl);
        popupEl = null;
        document.removeEventListener('keydown', onHotKey, true);
    }

    function onHotKey(ev) { if (ev.key === 'Escape') closeHotPopup(); }

    /* Styled to match the country-restriction dialog the ⓘ next to
       "Only USA/CA/UK" opens: dark card, rounded, one line of copy, one
       dismiss button. Built here rather than reused because that one is a
       React component this file cannot reach into. */
    function openHotPopup(deal, anchor) {
        closeHotPopup();

        /* -------------------------------------------------------------------
           A SMALL BOX BESIDE THE DEAL, NOT A MODAL OVER THE PAGE
           -------------------------------------------------------------------
           It used to be a centred card behind a dark blurred backdrop covering
           the whole window, which for one sentence of text reads as a
           full-screen interruption.

           Now: a compact panel anchored to the badge that was tapped, over a
           TRANSPARENT catcher that exists only so a click anywhere else closes
           it. Nothing dims, nothing blurs, and the deal stays in view behind
           the box it belongs to.
           ------------------------------------------------------------------- */
        popupEl = el('div', 'mv-hotpop-back');
        var card = el('div', 'mv-hotpop');

        var head = el('div', 'mv-hotpop-head');
        var icon = document.createElement('img');
        icon.src = HOT_ICON;
        icon.alt = '';
        icon.className = 'mv-hotpop-icon';
        head.appendChild(icon);
        head.appendChild(el('div', 'mv-hotpop-title', 'HOT DEAL'));
        card.appendChild(head);

        card.appendChild(el('div', 'mv-hotpop-body',
            'This is one of the most clicked deals today'));

        /* The number is only shown when the server sent one. Saying "34 clicks
           in the last 2 days" when the count is unknown would be inventing it,
           and a handpicked deal always has a count of 0, so it simply gets no
           number rather than a fabricated one. */
        var n = deal && deal.hot_clicks ? parseInt(deal.hot_clicks, 10) : 0;
        /* MV119 — hot_live is the clicks in the last 5 minutes (present when
           the server runs the MV119 rules); hot_clicks is the total. */
        var live = deal && deal.hot_live ? parseInt(deal.hot_live, 10) : 0;
        if (deal && deal.hot_live !== undefined) {
            var mins = Math.max(1, Math.round((hotRules.windowSec || 300) / 60));
            /* MV121 — two hours or more reads in hours ("in the last 12 hours"). */
            var span = (mins >= 120) ? (Math.round(mins / 60) + ' hours') : (mins + ' minutes');
            if (live > 0) card.appendChild(el('div', 'mv-hotpop-sub', live + ' clicks in the last ' + span));
            else if (n > 0) card.appendChild(el('div', 'mv-hotpop-sub', n + ' clicks in total'));
        } else if (n > 0) {
            card.appendChild(el('div', 'mv-hotpop-sub', n + ' clicks in the last 2 days'));
        }

        var ok = el('button', 'mv-hotpop-btn', 'Got it');
        ok.type = 'button';
        ok.addEventListener('click', function (ev) {
            ev.preventDefault(); ev.stopPropagation(); closeHotPopup();
        });
        card.appendChild(ok);

        card.addEventListener('click', function (ev) { ev.stopPropagation(); });
        popupEl.addEventListener('click', function (ev) {
            ev.preventDefault(); ev.stopPropagation(); closeHotPopup();
        });

        popupEl.appendChild(card);
        document.body.appendChild(popupEl);

        /* Every rule the box cannot do without, inline — the same reason as the
           badge: a stylesheet in /assets/ is already failing to load on this
           host, and an unstyled div would be a bare block of text over the
           page. */
        styleInline(popupEl, {
            'position': 'fixed', 'left': '0', 'top': '0', 'right': '0', 'bottom': '0',
            'z-index': '2147483000', 'background': 'transparent', 'display': 'block'
        });
        styleInline(card, {
            'position': 'absolute',
            'width': '250px', 'max-width': 'calc(100vw - 24px)',
            'box-sizing': 'border-box',
            'background': '#ffffff',
            'border': '2px solid #f97316',
            'border-radius': '12px',
            'padding': '10px 12px 12px',
            'text-align': 'center',
            'box-shadow': '0 10px 30px rgba(0,0,0,.28)',
            'font-family': 'inherit'
        });
        styleInline(head, {
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center',
            'gap': '6px', 'margin-bottom': '6px'
        });
        styleInline(icon, { 'width': '34px', 'height': 'auto', 'max-width': '34px', 'display': 'block' });
        styleInline(head.lastChild, {
            'font-size': '12px', 'font-weight': '900', 'letter-spacing': '.04em',
            'color': '#c2410c', 'text-transform': 'uppercase'
        });
        styleInline(card.querySelector('.mv-hotpop-body'), {
            'font-size': '11.5px', 'font-weight': '700', 'line-height': '1.4',
            'color': '#1f2937', 'margin': '0 0 10px'
        });
        var sub = card.querySelector('.mv-hotpop-sub');
        if (sub) styleInline(sub, { 'font-size': '10.5px', 'color': '#6b7280', 'margin': '-6px 0 10px' });
        styleInline(ok, {
            'display': 'block', 'width': '100%', 'padding': '8px 10px',
            'border': '0', 'border-radius': '8px',
            'background': '#22a24a', 'color': '#fff',
            'font-size': '12px', 'font-weight': '900', 'cursor': 'pointer',
            'box-sizing': 'border-box'
        });

        /* Place it under the badge, then pull it back inside the window if that
           would run it off an edge. Measured after it is in the DOM, because a
           box that has not been laid out has no size to work from. */
        var W = document.documentElement.clientWidth;
        var H = document.documentElement.clientHeight;
        var bw = card.offsetWidth || 250;
        var bh = card.offsetHeight || 130;
        var left, top;

        if (anchor && anchor.getBoundingClientRect) {
            var r = anchor.getBoundingClientRect();
            left = r.left + (r.width / 2) - (bw / 2);
            top  = r.bottom + 8;
            if (top + bh > H - 8) top = r.top - bh - 8;      // no room below: go above
        } else {
            left = (W - bw) / 2;
            top  = (H - bh) / 2;
        }
        if (left < 8) left = 8;
        if (left + bw > W - 8) left = W - bw - 8;
        if (top < 8) top = 8;

        card.style.setProperty('left', Math.round(left) + 'px', 'important');
        card.style.setProperty('top', Math.round(top) + 'px', 'important');

        document.addEventListener('keydown', onHotKey, true);
    }

    /* -----------------------------------------------------------------------
       LANGUAGE SWITCH, NO RELOAD
       -----------------------------------------------------------------------
       The logical inset above means the browser re-places the badges on its
       own the instant direction changes, so in a modern browser this watcher
       has nothing to correct.

       It exists for two other reasons. On a browser without logical inset the
       physical left/right written earlier is now on the wrong side and has to
       be rewritten. And the card carries .mv-hotcard-rtl for the stylesheet,
       which has to keep up either way.

       Cheap: it only does anything when the direction has ACTUALLY changed,
       which is a handful of times in a session at most.
       ----------------------------------------------------------------------- */
    var lastDir = null;

    function currentDir() {
        try {
            var panel = document.querySelector('.mv-hotcard') || document.body;
            return window.getComputedStyle(panel).direction || 'ltr';
        } catch (e) { return 'ltr'; }
    }

    /* -----------------------------------------------------------------------
       WHY THE LAYOUT KEPT COMING UNDONE
       -----------------------------------------------------------------------
       The numbers were right all along. Your own console proved it:

           {layout: 'two-line', card: '115px tall', linkLineTop: 77}

       which puts the badge at 9..68 and the button at 75..109 — a 7px gap.
       The layout was being COMPUTED correctly and then LOST.

       The deals list re-renders as you scroll and page. React reuses the card
       node but replaces the See Deal button inside it, and a replaced button
       is a new element with none of our inline transform on it — so it springs
       back to the title line while the badge stays where it was put. That is
       the overlap in your screenshot.

       Two things stopped it being repaired:

         this function returned early unless the READING DIRECTION had changed,
         so the periodic pass did nothing on an English-only page

         decorateHot() returned early for any card already marked, so a card
         whose button had been swapped was never looked at again

       Both are fixed. The pass now re-applies the layout every time it runs,
       and it is cheap: a handful of visible cards, measure and set.
       ----------------------------------------------------------------------- */
    function refreshBadgeSides() {
        var dir = currentDir();
        var dirChanged = (dir !== lastDir);
        lastDir = dir;

        var cards = document.querySelectorAll('.mv-hotcard');
        for (var i = 0; i < cards.length; i++) {
            var card = cards[i];
            if (dirChanged) {
                var rtl = isRtl(card);
                if (rtl) card.classList.add('mv-hotcard-rtl'); else card.classList.remove('mv-hotcard-rtl');
            }

            var badge = card.querySelector('.mv-hotbadge');
            var im = badge && badge.querySelector('img');
            if (!badge || !im) continue;

            /* Mode is read from the CLASS, not from position. Both modes are
               absolutely positioned now, so testing position told every badge
               it was pinned — which stripped the centring transform off the
               ones sitting in a reserved strip and pushed them to the card's
               edge the moment the language changed. */
            if (dirChanged) styleBadge(badge, im, card);
            var btn = null;
            var ctrls = card.querySelectorAll('button, a, div[role="button"]');
            for (var c2 = 0; c2 < ctrls.length; c2++) {
                if (isSeeDeal(ctrls[c2])) { btn = ctrls[c2]; break; }
            }
            applyHotLayout(card, btn, badge, im);
        }
    }

    function watchDirection() {
        try {
            /* MV119: coalesced to the next animation frame. Run straight from
               the observer, this pass read getComputedStyle() in the middle of
               whatever had just changed <html>/<body> (a stylesheet's onload,
               a class) and forced a full style recalculation of the page on
               the spot — 28 ms in the load event alone. In the frame it
               shares the browser's own style pass; it still runs before that
               frame is painted, so nothing is ever seen out of place. */
            var rbsQueued = false;
            var mo = new MutationObserver(function () {
                if (rbsQueued) return;
                rbsQueued = true;
                (window.requestAnimationFrame || window.setTimeout)(function () {
                    rbsQueued = false;
                    refreshBadgeSides();
                });
            });
            mo.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ['dir', 'lang', 'class', 'style']
            });
            if (document.body) {
                mo.observe(document.body, { attributes: true, attributeFilter: ['dir', 'class', 'style'] });
            }
        } catch (e) { /* the logical inset still covers the common case */ }

        // A language toggle re-renders the panel rather than the <html> tag, so
        // also re-check on the same beat the decorator already runs on.
        /* MV119: the periodic re-check goes through the same per-frame queue,
           so its measurements never force a layout between frames. */
        setInterval(function () {
            if (rbsQueued) return;
            rbsQueued = true;
            (window.requestAnimationFrame || window.setTimeout)(function () {
                rbsQueued = false;
                refreshBadgeSides();
            });
        }, 1200);
    }

    /* -----------------------------------------------------------------------
       THE WATERMARK
       -----------------------------------------------------------------------
       hot.png has a large, faint copy of the artwork sitting behind the card's
       text — and only on the hot cards; the ordinary card in that screenshot
       has none. I removed it in v11 believing it was the badge accidentally
       drawing at its natural 265x204 from a stale build. It was not. It is
       part of the design, so it is drawn deliberately now, at a size and
       opacity that are chosen rather than accidental.

       z-index:-1 is what puts it BEHIND the title and the price rather than
       over them. A negative z-index paints beneath the in-flow content of its
       stacking-context ancestor but still above that ancestor's own
       background, which is exactly the layer wanted: over the white card,
       under the text.

       No child of the card is touched to achieve that — an earlier idea was to
       give every child position:relative and a z-index, which would have
       re-anchored the absolutely-positioned discount badge sitting on the
       product image and moved it.
       ----------------------------------------------------------------------- */
    function addWatermark(card) {
        var old = card.querySelectorAll('.mv-hotwm');
        for (var i = 0; i < old.length; i++) old[i].remove();

        var wm = document.createElement('img');
        wm.src = HOT_ICON;
        wm.alt = '';
        wm.className = 'mv-hotwm';
        wm.setAttribute('aria-hidden', 'true');

        styleInline(wm, {
            'position': 'absolute',
            'top': '50%',
            'left': '50%',
            'transform': 'translate(-50%, -50%) rotate(-4deg)',
            'width': '78%',
            'max-width': '78%',
            'max-height': '88%',
            'height': 'auto',
            'opacity': '.13',
            'z-index': '-1',
            'pointer-events': 'none',
            'user-select': 'none',
            'margin': '0',
            'padding': '0'
        });

        card.appendChild(wm);
    }

    /* =======================================================================
       THE HOT CARD TREATMENT — red gradient, glow, pulse, shine
       =======================================================================
       Keyframes cannot be written inline on an element, so the animations live
       in a <style> tag this file injects. That also means they survive
       mavely-deals.v23.css failing to load, which is already happening to
       mavely-ui.v9.css on your host.

       prefers-reduced-motion is honoured: some people get motion sickness from
       looping animation, and a deal card is not worth that.
       ======================================================================= */
    /* -----------------------------------------------------------------------
       THE HOT CARD LOOK, FROM SETTINGS
       -----------------------------------------------------------------------
       Chosen in Blogger Configuration and delivered on the deals response, so
       the page needs no extra request. Applies to HOT cards only — an ordinary
       deal is never touched by any of this.
       ----------------------------------------------------------------------- */
    var HOT_STYLES = {
        red:    'linear-gradient(135deg,#FF4D2D 0%,#E01B32 55%,#B3122A 100%)',
        blue:   'linear-gradient(135deg,#2B7CF6 0%,#12B6E8 55%,#19D5C6 100%)',
        gold:   'linear-gradient(135deg,#FFC13B 0%,#F6A21B 55%,#E2860B 100%)',
        spots:  'radial-gradient(circle at 18% 26%,#E8342B 0 9%,transparent 10%),'
              + 'radial-gradient(circle at 62% 18%,#E8342B 0 7%,transparent 8%),'
              + 'radial-gradient(circle at 84% 62%,#E8342B 0 10%,transparent 11%),'
              + 'radial-gradient(circle at 34% 78%,#E8342B 0 8%,transparent 9%),'
              + 'linear-gradient(135deg,#FFC64A 0%,#F5A623 100%)',
        sunset: 'linear-gradient(135deg,#B14BE0 0%,#E0459B 45%,#F2A93B 100%)',
        coins:  'url(/assets/hotbg-coins.png)',
        store:  'url(/assets/hotbg-store.png)'
    };

    var hotLook = { style: 'red', image: '', effects: true };
    var hotRules = { windowSec: 300 };      // MV119, from /api/deals hotRules

    function hotBackground() {
        if (hotLook.style === 'custom' && hotLook.image) {
            return 'url("' + String(hotLook.image).replace(/"/g, '%22') + '")';
        }
        return HOT_STYLES[hotLook.style] || HOT_STYLES.red;
    }

    function hotIsImage() {
        return hotLook.style === 'custom' ? !!hotLook.image
             : (hotLook.style === 'coins' || hotLook.style === 'store');
    }

    var hotStylesInjected = false;

    function ensureHotStyles() {
        if (hotStylesInjected) return;
        hotStylesInjected = true;
        try {
            var st = document.createElement('style');
            st.id = 'mv-hot-fx';
            st.textContent = [
                /* THE GLOW is an inset shadow, so it is drawn within the card's
                   own edges rather than as a halo outside them. */
                /* MV119 — the glow is now a static inner shadow on the card
                   plus a second, stronger one on ::before whose OPACITY
                   pulses. Opacity is composited; box-shadow was repainted
                   every frame. At the peak the two add up to the old 50%. */
                '@keyframes mvHotGlowO{0%,100%{opacity:0}50%{opacity:1}}',

                '@keyframes mvHotBadge{',
                '0%,100%{transform:scale(1)}50%{transform:scale(1.055)}}',

                /* THE SHINE MOVES ITS BACKGROUND, NOT ITSELF.
                   It used to be a translated element, which meant the card had
                   to clip its children to stop the sweep escaping — and a card
                   that clips its children also clips the copy warning, which is
                   why that toast looked squashed and dark on a hot card while
                   it is a full-width banner everywhere else.

                   Animating background-position keeps the highlight inside the
                   element's own box, so nothing has to be clipped and the card
                   can go back to overflow:visible. */
                /* MV119 — the same sweep as a TRANSFORM: the band is 3x the
                   card's width (the old background-size:300%) and moves
                   exactly as the old background-position 220% -> -120% did,
                   inside its own clipping box (.mv-hotshine), so the card
                   still does not have to clip its children. */
                '@keyframes mvHotShineT{',
                '0%{transform:translate3d(-146.667%,0,0)}',
                '60%{transform:translate3d(80%,0,0)}',
                '100%{transform:translate3d(80%,0,0)}}',

                '.mv-hotshell{position:relative!important;border-radius:14px!important;',
                'background-size:cover!important;background-position:center!important;',
                'box-shadow:inset 0 0 0 1px rgba(255,255,255,.16),inset 0 0 18px rgba(255,255,255,.05);}',
                '.mv-hotshell::before{content:"";position:absolute;top:0;right:0;bottom:0;left:0;',
                'pointer-events:none;border-radius:14px;z-index:-1;opacity:0;',
                'box-shadow:inset 0 0 0 1px rgba(255,255,255,.21),inset 0 0 26px rgba(255,255,255,.12);',
                'animation:mvHotGlowO 2.8s ease-in-out infinite;}',

                /* the old ::after sweep is kept as a no-op box so nothing
                   that sized itself around it moves */
                '.mv-hotshell::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;',
                'pointer-events:none;border-radius:14px;',
                /* z-index:-1 puts it behind the card's content but still above
                   the card's own background. No rule is applied to the card's
                   CHILDREN at all — the previous version set position:relative
                   on every one of them, which took the absolutely positioned
                   copy warning out of its own layout and left it as a small
                   block inside the card. That is the bug in art.png. */
                'z-index:-1;',
                'background:none;}',
                '.mv-hotshine{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:14px;',
                'overflow:hidden;pointer-events:none;z-index:-1;}',
                '.mv-hotshine>i{position:absolute;top:0;bottom:0;left:0;width:300%;display:block;',
                'background:linear-gradient(100deg,transparent 35%,rgba(255,255,255,.38) 50%,transparent 65%);',
                'transform:translate3d(-146.667%,0,0);will-change:transform;',
                'animation:mvHotShineT 4.6s ease-in-out infinite;}',

                '.mv-hotbadge{animation:mvHotBadge 2.2s ease-in-out infinite;z-index:3!important;}',

                '.mv-hotshell-nofx{animation:none!important;}',
                '.mv-hotshell-nofx::after,.mv-hotshell-nofx::before,.mv-hotshell-nofx>.mv-hotshine{display:none!important;}',
                '.mv-hotshell-nofx .mv-hotbadge{animation:none!important;}',

                '@media (prefers-reduced-motion: reduce){',
                '.mv-hotshell,.mv-hotshell::after,.mv-hotshell::before,.mv-hotbadge,.mv-hotshine>i{animation:none!important}',
                '.mv-hotshell::after,.mv-hotshine{display:none}}'
            ].join('');
            (document.head || document.documentElement).appendChild(st);
        } catch (e) { /* the badge still shows, just without the effects */ }
    }

    /* -----------------------------------------------------------------------
       PAINT THE CARD, AND ONLY THE CARD
       -----------------------------------------------------------------------
       v23 climbed outward looking for the "real" card, allowing a parent up to
       20px wider. On your layout that overshot and painted a wrapper wider than
       the card, so the colour ran past the card's edge and out across the list.

       No climbing now. The element painted is the one the badge is anchored to
       — the innermost box that holds both the deal image and the See Deal
       button, which IS the card. It cannot be wider than the card because it is
       the card.
       ----------------------------------------------------------------------- */
    function paintHotShell(card) {
        if (!card) return null;
        ensureHotStyles();

        card.classList.add('mv-hotshell');
        if (!hotLook.effects) card.classList.add('mv-hotshell-nofx');
        else card.classList.remove('mv-hotshell-nofx');
        /* MV119 — the shine's own clipping box, appended (never inserted),
           as every addition in this file is. */
        var shine = null;
        for (var sc = 0; sc < card.children.length; sc++) {
            if (card.children[sc].classList && card.children[sc].classList.contains('mv-hotshine')) { shine = card.children[sc]; break; }
        }
        if (!shine) {
            shine = document.createElement('span');
            shine.className = 'mv-hotshine';
            shine.setAttribute('aria-hidden', 'true');
            shine.appendChild(document.createElement('i'));
            card.appendChild(shine);
        }

        /* Inline as well as in the injected style, so the background survives a
           stylesheet that fails to load — which is already happening to
           mavely-ui.v9.css on your host. */
        card.style.setProperty('background', hotBackground(), 'important');
        card.style.setProperty('border-radius', '14px', 'important');
        /* NOT hidden. A card that clips its children also clips the copy
           warning banner, which is what made that toast look different on a
           hot card. The shine no longer needs clipping — it moves its
           background rather than itself. */
        card.style.setProperty('overflow', 'visible', 'important');
        if (hotIsImage()) {
            card.style.setProperty('background-size', 'cover', 'important');
            card.style.setProperty('background-position', 'center', 'important');
        }
        return card;
    }

    function unpaintHotShell(card) {
        if (!card) return;
        card.classList.remove('mv-hotshell', 'mv-hotshell-nofx');
        for (var sc = card.children.length - 1; sc >= 0; sc--) {       // MV119
            var ch = card.children[sc];
            if (ch.classList && ch.classList.contains('mv-hotshine')) card.removeChild(ch);
        }
        card.style.removeProperty('background');
        card.style.removeProperty('background-size');
        card.style.removeProperty('background-position');
        card.style.removeProperty('border-radius');
        card.style.removeProperty('overflow');
    }

    function decorateHot(img, deal) {
        if (!deal || !deal.is_hot) {
            /* This card may have BEEN hot a moment ago — the deals list reuses
               its nodes as you page through. Leaving the reserved strip behind
               would give an ordinary deal a tall empty gap above its button. */
            try {
                var was = findBadgeHost(img);
                if (was && was.card && was.card.getAttribute('data-mv-hot')) {
                    var b0 = was.card.querySelectorAll('.mv-hotbadge, .mv-hotwm');
                    for (var q = 0; q < b0.length; q++) b0[q].remove();
                    releaseButton(was.btn);
                    releaseSpace(was.host);
                    unpaintHotShell(was.card);
                    was.card.removeAttribute('data-mv-hot');
                    was.card.classList.remove('mv-hotcard', 'mv-hotcard-rtl');
                }
            } catch (e) {}
            return;
        }

        var found = findBadgeHost(img);
        if (!found) return;
        var host = found.host, card = found.card;

        /* SELF-HEALING. It is not enough that this card was decorated once: the
           list reuses card nodes and replaces the button inside them, and a
           replaced button has lost our transform. So the work is skipped only
           when the decoration is still ALL THERE — the same deal, a badge in
           place, and a button that still carries the marker we put on it. Any
           of those missing and it is redone. */
        if (card.getAttribute('data-mv-hot') === String(deal.id)) {
            var haveBadge = !!card.querySelector('.mv-hotbadge');
            var liveBtn = null;
            var ctrls = card.querySelectorAll('button, a, div[role="button"]');
            for (var cc = 0; cc < ctrls.length; cc++) {
                if (isSeeDeal(ctrls[cc])) { liveBtn = ctrls[cc]; break; }
            }
            var btnIntact = !liveBtn || liveBtn.hasAttribute('data-mv-tf0');
            if (haveBadge && btnIntact) return;

            // Something was replaced under us. Clear and rebuild.
            var stale = card.querySelectorAll('.mv-hotbadge, .mv-hotwm');
            for (var sx = 0; sx < stale.length; sx++) stale[sx].remove();
            card.removeAttribute('data-mv-hot');
        }
        card.setAttribute('data-mv-hot', String(deal.id));

        // A recycled node may still carry the previous deal's badge.
        var old = card.querySelectorAll('.mv-hotbadge');
        for (var i = 0; i < old.length; i++) old[i].remove();

        /* Anything holding the artwork that is NOT one of our buttons is a
           leftover from an earlier build still in the page — that is what the
           giant faint starburst across the card was. Swept, so a card can only
           ever carry one badge at one size. */
        /* Anything the old artwork left behind — a starburst badge or the big
           faint watermark from a previous version still in the page. */
        var strays = card.querySelectorAll('img[src*="hot-deals"], .mv-hotwm');
        for (var s2 = 0; s2 < strays.length; s2++) strays[s2].remove();

        card.classList.add('mv-hotcard');

        var badge = el('button', 'mv-hotbadge');
        badge.type = 'button';
        badge.title = 'Hot deal — one of the most clicked today';
        badge.setAttribute('aria-label', 'Hot deal');
        badge.innerHTML = buildBadgeSvg();
        var im = badge.querySelector('svg');

        /* stopPropagation matters: the card and the image around it have their
           own click handlers (copy / open the deal), and tapping the badge must
           not fire either of them. */
        badge.addEventListener('click', function (ev) {
            ev.preventDefault(); ev.stopPropagation();
            openHotPopup(deal, badge);
        });

        var rtl = isRtl(card);
        if (rtl) card.classList.add('mv-hotcard-rtl'); else card.classList.remove('mv-hotcard-rtl');

        /* The card has to be a positioning context for the badge to sit against
           it. Written with priority, because a utility class setting
           position:static would otherwise drop the badge to the page corner. */
        card.style.setProperty('position', 'relative', 'important');
        /* So the watermark cannot spill past the card's rounded corners. Only
           set when it is not already clipping, to leave an existing choice be. */
        /* The card must NOT clip: the badge overhangs its top-right corner by a
           few pixels, exactly as in deals.png, and a clipping card would slice
           that overhang off. The watermark is kept inside by its own max-width
           and max-height instead of by clipping the card. */
        card.style.setProperty('overflow', 'visible', 'important');

        // Inline the essentials, so a missing stylesheet cannot hide it.
        styleBadge(badge, im, card);

        card.appendChild(badge);
        paintHotShell(card);
        /* The big faint starburst is gone with the starburst badge. It belonged
           to the old artwork and would fight the new pill for attention — you
           asked for clean, and a card carrying both is not. */

        /* Measured only after everything is in the page — an element that has
           not been laid out has no position to read. Repeated on the next
           frame and again shortly after, because a card whose image is still
           loading has not reached its final height and the button would be
           measured somewhere it is about to leave. */
        applyHotLayout(card, found.btn, badge, im);
        if (window.requestAnimationFrame) {
            requestAnimationFrame(function () { applyHotLayout(card, found.btn, badge, im); });
        }
        setTimeout(function () { applyHotLayout(card, found.btn, badge, im); }, 350);
    }

    function decorateCard(img) {
        var src = img.getAttribute('src') || '';
        if (!src) return;

        // srcs may be absolute; compare on the path only.
        var path = src.replace(/^https?:\/\/[^/]+/, '');
        var deal = dealsByImage[path] || dealsByImage[src];
        if (!deal) return;

        // Item 9 first, and on its own guard, so a card already decorated with
        // price and badges still gains its hot badge when the map arrives.
        decorateHot(img, deal);

        var box = img.parentElement;                       // the 64x64 image button
        if (!box) return;
        if (box.getAttribute('data-mv-priced') === String(deal.id)) return;   // done
        box.setAttribute('data-mv-priced', String(deal.id));

        // Remove any decoration from a previous deal on a recycled node.
        var stale = box.querySelectorAll('.mv-badge-new, .mv-badge-off, .mv-price');
        for (var s = 0; s < stale.length; s++) stale[s].remove();

        box.classList.add('mv-imgbox');

        // --- item 7: NEW badge -------------------------------------------
        // is_new is set by get_deals_for_visitor() on the ten most recent
        // deals. Your backend has always sent it; nothing has ever read it.
        if (deal.is_new) box.appendChild(el('span', 'mv-badge-new', 'NEW'));

        // --- item 1: discount badge over the image ------------------------
        if (deal.discount) box.appendChild(el('span', 'mv-badge-off', deal.discount));

        // --- item 1: price row under the image ----------------------------
        if (deal.price) {
            var row = el('span', 'mv-price');
            row.appendChild(el('span', 'mv-price-now', deal.price));
            if (deal.old_price) row.appendChild(el('span', 'mv-price-was', deal.old_price));
            // The image button copies the picture when clicked. Tapping the
            // price should not fire that.
            row.addEventListener('click', function (ev) { ev.stopPropagation(); ev.preventDefault(); });
            box.appendChild(row);
        }
    }

    function decorate() {
        var imgs = document.querySelectorAll('img[alt="Deal product"]');
        if (!imgs.length) return;
        if (!Object.keys(dealsByImage).length) { loadDeals(); return; }

        var missed = 0;
        for (var i = 0; i < imgs.length; i++) {
            var before = imgs[i].parentElement &&
                         imgs[i].parentElement.getAttribute('data-mv-priced');
            decorateCard(imgs[i]);
            if (!before && imgs[i].parentElement &&
                !imgs[i].parentElement.getAttribute('data-mv-priced')) missed++;
        }
        // A page of cards none of which are in the map means the list moved on
        // (pagination, a store filter). Refresh once.
        if (missed && missed === imgs.length && Date.now() - fetchedAt > 3000) {
            fetchedAt = 0;
            loadDeals();
        }
    }

    /* ---------------------------------------------------------------------
       ITEM 5 — the sort filters
       ---------------------------------------------------------------------
       Sorting happens on the SERVER (api/deals.php reads ?sort= or the
       mv_deal_sort cookie). It cannot be done here: the list paginates in the
       browser over whatever the API returned, so reordering the DOM would only
       reorder the rows currently on screen — "High Price" would show the
       dearest of page one, not the dearest of 1,342 deals.

       So the buttons set the cookie and reload once. One reload, correct
       results, and the choice survives paging and tab switching.
       --------------------------------------------------------------------- */

    var FILTERS = [
        /* Hot Deals first: it is a FILTER, not a sort — it changes WHICH deals
           are listed rather than their order — so it gets its own group below
           and can be combined with any of the others. */
        { key: 'hot',        label: 'Hot Deals', hot: true },
        { key: 'price_high', label: 'High Price' },
        { key: 'price_low',  label: 'Low Price'  },
        { key: 'sold_high',  label: 'High Sold %' },
        { key: 'sold_low',   label: 'Low Sold %'  },
        /* MV124 — the JEV score, its own group (see sortGroup) */
        { key: 'score_high', label: 'High Score' },
        { key: 'score_low',  label: 'Low Score'  }
    ];

    function currentSort() {
        var m = document.cookie.match(/(?:^|;\s*)mv_deal_sort=([^;]*)/);
        return m ? decodeURIComponent(m[1]) : '';
    }

    function activeSorts() {
        var out = [];
        currentSort().split(',').forEach(function (k) {
            k = k.trim();
            if (k) out.push(k);
        });
        return out;
    }

    function sortGroup(key) {
        if (key === 'hot') return 'hot';                  // its own group: toggles alone
        if (key.indexOf('score') === 0) return 'score';   // MV124
        return key.indexOf('price') === 0 ? 'price' : 'sold';
    }

    /* One price filter AND one sold filter can now be active together.
       Tapping a filter selects it within its own group, replacing whatever else
       in that group was on; tapping the same one again clears it. So "High
       Price" and "Low Price" can never both be lit, but "Low Price" and
       "High Sold %" can. */
    function setSort(key) {
        var cur = activeSorts();
        var g = sortGroup(key);
        var next = [];
        var had = false;

        cur.forEach(function (k) {
            if (sortGroup(k) !== g) { next.push(k); return; }
            if (k === key) had = true;             // dropped: tapping toggles off
        });
        if (!had) next.push(key);

        // price, sold, score, hot — so the cookie is stable and easy to read (MV124)
        var ORDER = { price: 0, sold: 1, score: 2, hot: 3 };
        next.sort(function (a, b) { return ORDER[sortGroup(a)] - ORDER[sortGroup(b)]; });

        var val = next.join(',');
        document.cookie = SORT_COOKIE + '=' + encodeURIComponent(val) +
                          ';path=/;max-age=' + (val ? 2592000 : 0) + ';SameSite=Lax';
        window.location.reload();
    }

    function clearSort() {
        document.cookie = SORT_COOKIE + '=;path=/;max-age=0;SameSite=Lax';
        window.location.reload();
    }

    /* ITEM 3 — the Download ZIP button does not belong in Manual Deals.
       The same panel component renders both tabs, so it cannot be removed
       outright. It is marked only when the panel it sits in is the manual one,
       identified by that panel's own heading. Re-applied on every pass, so a
       React re-render cannot bring it back. */
    function hideManualZip() {
        var buttons = document.querySelectorAll('button');
        for (var i = 0; i < buttons.length; i++) {
            var b = buttons[i];
            var t = (b.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
            if (t !== 'DOWNLOAD ZIP' && t !== 'تحميل ZIP') continue;

            var manual = false;
            var n = b;
            for (var up = 0; up < 8 && n.parentElement; up++) {
                n = n.parentElement;
                var txt = (n.textContent || '').toUpperCase();
                if (txt.indexOf('MANUAL DEAL') !== -1) { manual = true; break; }
                if (txt.indexOf('DEALS LIST') !== -1) break;   // the other tab
            }
            b.classList[manual ? 'add' : 'remove']('mv-zip-hidden');
        }
    }

    function injectFilters() {
        /* v1 located this row by the Download ZIP button's title attribute, and
           that was the bug you hit: the title is NOT constant. React writes

               title = x ? "Download ZIP"
                         : "Enable 'My Selected Deals' first to download"

           so with the checkbox unticked the title never matched and the bar was
           never injected. That is exactly why the filters only appeared once
           "My Selected Deals" was on.

           The "My Selected Deals" label is present either way, so it is the
           anchor now. The filters show at all times. */
        var host = null;
        var labels = document.querySelectorAll('label');
        for (var i = 0; i < labels.length; i++) {
            var t = (labels[i].textContent || '').replace(/\s+/g, ' ').trim();
            if (t === 'My Selected Deals' || t === 'عروضي المحددة') {
                host = labels[i].parentElement;
                break;
            }
        }
        if (!host) return false;
        if (host.querySelector('.mv-sortbar')) return true;

        var bar = el('div', 'mv-sortbar');
        var active = activeSorts();
        FILTERS.forEach(function (f) {
            /* MV124 — no score buttons while the JEV panel hides the scores */
            if (f.key.indexOf('score') === 0 && window.__mvJevCfg && (window.__mvJevCfg.show === false || window.__mvJevCfg.scores === false)) return;   // no scores shown / none yet
            var isOn = active.indexOf(f.key) !== -1;
            var b = el('button',
                'mv-sortbtn' + (f.hot ? ' is-hot-btn' : '') + (isOn ? ' is-on' : ''),
                f.label);
            b.type = 'button';
            b.addEventListener('click', function (ev) {
                ev.preventDefault(); ev.stopPropagation();
                setSort(f.key);
            });
            bar.appendChild(b);
        });
        if (active.length) {
            var clr = el('button', 'mv-sortbtn mv-sortclear', 'Clear');
            clr.type = 'button';
            clr.addEventListener('click', function (ev) {
                ev.preventDefault(); ev.stopPropagation(); clearSort();
            });
            bar.appendChild(clr);
        }
        host.appendChild(bar);        // appended, then CSS order puts it below
        host.classList.add('mv-ziprow');
        injectImageOptions(host);     // the three image checkboxes, same row
        return true;
    }

    /* ---------------------------------------------------------------------
       ITEM 3 — the "Add Price" checkbox
       ---------------------------------------------------------------------
       Appended to the row that holds "Store Logo" and "Multi Deals in same
       landing page", then moved in FRONT of Multi Deals with CSS order, per
       soldlanding_page.png. Appending keeps React's own two labels untouched.

       The value rides along on POST /api/shorten through a fetch wrapper.
       landing_extras_sanitize() already accepts and validates addPrice, and
       landing_render_html() already renders the price row when it is on, so
       the server half has been waiting for this since V25.
       --------------------------------------------------------------------- */

    function addPriceOn() {
        try { return localStorage.getItem(PRICE_KEY) === '1'; } catch (e) { return false; }
    }

    function injectAddPrice() {
        var labels = document.querySelectorAll('label');
        var multi = null;
        for (var i = 0; i < labels.length; i++) {
            var t = (labels[i].textContent || '').trim();
            if (t === 'Multi Deals in same landing page' ||
                t === 'صفقات متعددة في نفس صفحة المعاينة') { multi = labels[i]; break; }
        }
        if (!multi) return false;

        var host = multi.parentElement;
        if (!host || host.querySelector('.mv-addprice')) return true;

        var lab = el('label', 'mv-addprice');
        var box = el('input');
        box.type = 'checkbox';
        box.checked = addPriceOn();
        box.addEventListener('change', function () {
            try { localStorage.setItem(PRICE_KEY, box.checked ? '1' : '0'); } catch (e) {}
        });
        lab.appendChild(box);
        lab.appendChild(el('span', null, 'Add Price'));

        host.appendChild(lab);            // appended; CSS order puts it first
        host.classList.add('mv-optrow');
        multi.classList.add('mv-multi');
        return true;
    }

    /* Attach addPrice to the shorten request. Wrapped in try/catch and always
       falls through to the original fetch, so a failure here can never stop a
       link being created. */
    (function wrapFetch() {
        if (!window.fetch) return;
        var orig = window.fetch;
        window.fetch = function (input, init) {
            var url = '';
            try {
                url = (typeof input === 'string') ? input : (input && input.url) || '';

                if (init && init.body && typeof init.body === 'string' &&
                    /\/api\/shorten/.test(url) &&
                    String(init.method || '').toUpperCase() === 'POST') {
                    var body = JSON.parse(init.body);
                    body.addPrice = addPriceOn();
                    init = Object.assign({}, init, { body: JSON.stringify(body) });
                }

                /* ITEM 2 — the deal list must never come from cache.
                   The server now says no-store as well; this covers a response
                   already sitting in the browser cache from before that change,
                   so it starts working without waiting for the old copy to
                   expire. */
                if (/\/api\/deals(\?|$)/.test(url)) {
                    init = Object.assign({}, init || {}, { cache: 'no-store' });
                }
            } catch (e) { /* fall through untouched */ }

            var p = orig.call(this, input, init);

            /* After a manual deal is added, tell the tab to reload. The tab
               already listens for this event — it is the same one the shortener
               fires — so this reuses a refresh path that exists rather than
               inventing one. Belt and braces alongside the cache fix: the tab
               refetches after adding anyway, and this catches the case where
               the write lands a moment after that refetch. */
            try {
                if (/manual-fetch/.test(url) &&
                    String((init && init.method) || '').toUpperCase() === 'POST') {
                    p.then(function (res) {
                        if (!res || !res.ok) return res;
                        window.setTimeout(function () {
                            fetchedAt = 0;                       // drop our own cache
                            try { window.dispatchEvent(new Event('sh_link_shortened')); } catch (e) {}
                        }, 250);
                        return res;
                    }).catch(function () {});
                }
            } catch (e) {}

            return p;
        };
    })();

    /* ---------------------------------------------------------------------
       ITEMS 3 + 4 + 5 — the three image checkboxes
       ---------------------------------------------------------------------
       Appended to the same row as the filters, then placed by CSS order — the
       appendChild-only rule again, so React's own controls are never moved.

       Each gets its own accent colour, as asked.

       The copy handler is intercepted rather than replaced: when neither image
       option is on, the click falls straight through to the app's existing
       copy and nothing changes. Only with an option ticked do we take over and
       put a composited PNG on the clipboard instead.
       --------------------------------------------------------------------- */

    var IMG_OPTS = [
        { key: 'mv_img_logo',    label: 'ADD LOGO TO IMAGE',  cls: 'mv-opt-logo'  },
        { key: 'mv_img_price',   label: 'ADD PRICE TO IMAGE', cls: 'mv-opt-price' },
        { key: 'mv_title_price', label: 'ADD PRICE TO TITLE', cls: 'mv-opt-title' },
        /* MV111 — the fourth option. Same shape as the three above, so it gets
           the same checkbox, the same localStorage handling and the same place
           in the row with no other change. The banner itself is drawn by
           assets/mavely-linkcomments.v1.js; this line only puts the control on
           screen. */
        { key: 'mv_img_linkcomments', label: 'ADD LINK IN COMMENTS', cls: 'mv-opt-linkcomments' }
    ];

    function optOn(k) { try { return localStorage.getItem(k) === '1'; } catch (e) { return false; } }

    function injectImageOptions(host) {
        if (!host || host.querySelector('.mv-imgopts')) return;

        var bar = el('div', 'mv-imgopts');
        IMG_OPTS.forEach(function (o) {
            var lab = el('label', 'mv-imgopt ' + o.cls);
            lab.setAttribute('data-mv-imgopt', o.key);
            var box = el('input');
            box.type = 'checkbox';
            box.checked = optOn(o.key);
            box.addEventListener('change', function () {
                try { localStorage.setItem(o.key, box.checked ? '1' : '0'); } catch (e) {}
            });
            lab.appendChild(box);
            lab.appendChild(el('span', null, o.label));
            bar.appendChild(lab);
        });
        host.appendChild(bar);
    }

    /* Intercept the deal-image copy so the clipboard gets the composited PNG.
       Capture phase, so we run before React's own handler and can stop it when
       we are taking over. */
    function isShortened(deal, btn) {
        if (deal && deal.is_shortened && deal.custom_short_link) return true;

        // Fall back to the card itself, which is never stale.
        var card = btn;
        for (var i = 0; i < 5 && card; i++) {
            card = card.parentElement;
            if (!card) break;
            var t = (card.textContent || '').toUpperCase();
            if (t.indexOf('NEW SHORTEN LINK') !== -1) return true;
            if (card.className && String(card.className).indexOf('rounded-2xl') !== -1) break;
        }
        return false;
    }

    function armCopyIntercept() {
        if (window.__mvCopyArmed) return;
        window.__mvCopyArmed = true;

        document.addEventListener('click', function (ev) {
            if (!window.MavelyImg) return;
            /* MV111 — the new option counts as "something to add" too.
               Without this the interceptor bailed whenever logo and price were
               both off, so ticking ONLY Add Link In Comments fell through to
               the app's plain copy and no banner appeared. The check is
               optional-chained through a function that may not exist, so if
               mavely-linkcomments.v1.js is ever removed this line reads exactly
               as it did in v28. */
            var wantLC = !!(window.MavelyImg.linkComments && window.MavelyImg.linkComments());
            if (!window.MavelyImg.logo() && !window.MavelyImg.price() && !wantLC) return;   // nothing to add

            var btn = ev.target && ev.target.closest ? ev.target.closest('button') : null;
            if (!btn) return;
            var img = btn.querySelector('img[alt="Deal product"]');
            if (!img) return;

            var path = (img.getAttribute('src') || '').replace(/^https?:\/\/[^/]+/, '');
            var deal = dealsByImage[path] || dealsByImage[img.getAttribute('src')];
            if (!deal) return;                       // unknown deal, let the app handle it

            /* ITEM 1 — the edited image is only available once the deal has been
               shortened. The app already enforces this for its own copy:

                   if ((s==="description"||s==="image"||s==="post")
                       && !(t.is_shortened && t.custom_short_link)) { ...warn; return }

               and taking over the click was bypassing it. So we now check the
               same condition and, when it fails, do NOT preventDefault — the
               click carries on to the app's own handler, which shows its
               existing "You must shorten the link first" warning. Reusing that
               warning rather than inventing a second one keeps the message and
               its styling identical to everywhere else in the app.

               The DOM is consulted as well as the cached record: if the deal was
               shortened in the last few seconds our copy of /api/deals may not
               know yet, and the card's green NEW SHORTEN LINK badge does. */
            if (!isShortened(deal, btn)) return;

            ev.preventDefault();
            ev.stopPropagation();

            btn.classList.add('mv-copying');
            window.MavelyImg.copyDealImage(deal)
                .then(function (done) {
                    btn.classList.remove('mv-copying');
                    btn.classList.add(done ? 'mv-copied' : 'mv-copyfail');
                    window.setTimeout(function () {
                        btn.classList.remove('mv-copied', 'mv-copyfail');
                    }, 1600);
                })
                .catch(function () {
                    btn.classList.remove('mv-copying');
                    btn.classList.add('mv-copyfail');
                    window.setTimeout(function () { btn.classList.remove('mv-copyfail'); }, 2200);
                });
        }, true);
    }

    /* ---------------------------------------------------------------------
       LANDING PAGE CARDS
       ---------------------------------------------------------------------
       The page at /?code is NOT landing_render_html(). index.php serves the
       SPA and injects window.__INITIAL_LINK_DATA__, and React's redirect
       screen paints the cards. That is why the PHP price row added in V25
       never appeared: it renders a page this route does not use.

       So the price is injected here too. Same appendChild-only rule.

       Card structure, from the bundle:
           <a href={destination}>
             <div wrapper>
               <div p-3.5 flex flex-col>      <- the column
                 <div store row>
                 <div image bg> <img referrerPolicy="no-referrer"> </div>
                 <span title> <p desc> <div verified>
               <div> <button CONFIRM & GO TO RETAILER >

       The discount badge is appended to the image box, the price to the
       column. Appending puts the price after the verified line, which is
       exactly where the middle card in landing_page.png has it.
       --------------------------------------------------------------------- */

    /* v2 decided "is this a landing page?" with

           window.__INITIAL_LINK_DATA__ || document.querySelector('img[referrerpolicy]')

       and that second half was wrong. The bundle sets referrerPolicy on 14
       different images, several of them previews that render on the HOME page.
       So the home page matched, refresh() took the landing branch and returned
       early, and decorate(), injectFilters() and injectAddPrice() never ran.
       One bad line removed prices, the NEW badge, the filters and the Add Price
       checkbox all at once — exactly what you saw.

       There is no mode branch any more. All four jobs run every pass and each
       one is already a no-op when its target is absent, so nothing can be
       skipped by a misread of which page this is.

       The only thing still gated is the discriminator below, and it uses a
       POSITIVE signal for the app — the tool toolbar or a deal image, neither
       of which exists on a landing page — rather than guessing from an
       attribute that turned out not to be exclusive. */

    /* The toolbar this page has and a landing page does not. */
    var TOOLBAR_LABELS = [
        'ADD LOGO TO IMAGE', 'ADD PRICE TO IMAGE', 'ADD PRICE TO TITLE',
        'ADD LINK IN COMMENTS',                     /* MV111 — additive */
        'MY SELECTED DEALS', 'DOWNLOAD ZIP'
    ];

    function labelMatches(node, labels) {
        if (!node) return false;
        var t = (node.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
        if (!t || t.length > 60) return false;
        for (var i = 0; i < labels.length; i++) {
            if (t.indexOf(labels[i]) !== -1) return true;
        }
        return false;
    }

    /* FIXED. This called matches(), which does not exist anywhere in this file
       and never has — it threw

           Uncaught ReferenceError: matches is not defined

       every time it was reached, which is whenever the check ran before the
       deal images had rendered. The throw escaped the try/catch around the
       call site, because the call was OUTSIDE the try, so the rest of that
       pass was abandoned.

       Now it uses a real helper, and the whole thing is wrapped so a future
       mistake here degrades instead of aborting. */
    function isAppPage() {
        try {
            if (document.querySelector('img[alt="Deal product"]')) return true;
            var btns = document.querySelectorAll('button, label');
            for (var i = 0; i < btns.length; i++) {
                if (labelMatches(btns[i], TOOLBAR_LABELS)) return true;
            }
        } catch (e) { return true; }   // unsure: treat as the app and touch nothing
        return false;
    }

    function landingCards() {
        var imgs = document.querySelectorAll('img[referrerpolicy="no-referrer"]');
        var out = [];
        for (var i = 0; i < imgs.length; i++) {
            var box = imgs[i].parentElement;
            var col = box && box.parentElement;
            var a = imgs[i].closest ? imgs[i].closest('a[href]') : null;
            if (box && col) out.push({ img: imgs[i], box: box, col: col, href: a ? a.getAttribute('href') : '' });
        }
        return out;
    }

    function paintLanding(card, p) {
        if (!p || !p.price) return;
        if (card.col.getAttribute('data-mv-lp') === p.price) return;
        card.col.setAttribute('data-mv-lp', p.price);

        var stale = card.col.querySelectorAll('.mv-lp-price');
        for (var s = 0; s < stale.length; s++) stale[s].remove();
        var staleB = card.box.querySelectorAll('.mv-lp-off');
        for (var b = 0; b < staleB.length; b++) staleB[b].remove();

        if (p.discount) {
            card.box.classList.add('mv-lp-imgbox');
            card.box.appendChild(el('span', 'mv-lp-off', p.discount));
        }

        var row = el('div', 'mv-lp-price');
        row.appendChild(el('span', 'mv-lp-now', p.price));
        if (p.old_price) row.appendChild(el('span', 'mv-lp-was', p.old_price));
        card.col.appendChild(row);
    }

    var landingDone = false;

    function decorateLanding() {
        var cards = landingCards();
        if (!cards.length) return;

        var boot = window.__INITIAL_LINK_DATA__ || null;
        var need = [];

        for (var i = 0; i < cards.length; i++) {
            // The main card's price rides along in the bootstrap payload that
            // index.php injects, so it needs no request at all.
            if (boot && boot.price && i === 0) {
                paintLanding(cards[i], boot);
                continue;
            }
            if (cards[i].href && cards[i].href.indexOf('#') !== 0) need.push(cards[i]);
        }

        if (!need.length || landingDone) return;
        landingDone = true;

        var urls = need.map(function (c) { return c.href; }).join('|');
        fetch('/api/deal-price.php?urls=' + encodeURIComponent(urls), { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
                if (!j || !j.prices) return;
                for (var k = 0; k < need.length; k++) {
                    var p = j.prices[need[k].href];
                    if (p) paintLanding(need[k], p);
                }
            })
            .catch(function () { landingDone = false; });
    }

    /* ---------------------------------------------------------------------
       DRIVER
       --------------------------------------------------------------------- */

    var due = null;
    function refresh() {
        if (due) return;
        due = window.setTimeout(function () {
            due = null;
            /* No early return, ever. Each of these is self-guarding: decorate()
               does nothing without deal images, injectFilters() does nothing
               without the My Selected Deals label, injectAddPrice() does nothing
               without the options row. Running them all is both cheaper than a
               wrong branch and impossible to get wrong. */
            try { decorate(); } catch (e) {}
            try { injectFilters(); } catch (e) {}
            try { injectAddPrice(); } catch (e) {}
            try { injectWatermarkControls(); } catch (e) {}
            try { applyTabVisibility(); } catch (e) {}
            try { hideManualZip(); } catch (e) {}
            try { applyImageOptionHiding(); } catch (e) {}
            // Landing cards only when this is clearly NOT the app, so the
            // shortener's own preview images are never touched.
            try { if (!isAppPage()) decorateLanding(); } catch (e) {}
        }, 150);
    }

    /* MV119 — run fn once every deferred script has executed (DOMContentLoaded
       fires after them). If this file ever runs later than that, a short
       timer is the fallback, so the list is never left unloaded. */
    function mvAfterScripts(fn) {
        var done = false;
        function go() { if (done) return; done = true; try { fn(); } catch (e) {} }
        if (window.__mvDealsFlowLoaded || document.readyState === 'complete') { go(); return; }
        document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 0); }, { once: true });
        setTimeout(go, 2500);
    }

    function start() {
        armCopyIntercept();
        // Skip the deals fetch on a link page — it is the one genuinely
        // expensive call and a landing page has no use for it. Everything else
        // runs unconditionally.
        /* MV119 — see the header: after every deferred script, so the list
           comes from mavely-dealsflow's memory instead of the network. */
        if (!window.__INITIAL_LINK_DATA__) mvAfterScripts(function () { loadDeals(); });
        refresh();
        var mvSlowTimer = null;   // MV115
        function refreshSlow() {
            if (mvSlowTimer) return;
            mvSlowTimer = setTimeout(function () { mvSlowTimer = null; refresh(); }, 2000);
        }
        if (window.MutationObserver) {
            new MutationObserver(function (recs) {
                /* MV115 PERF — additions that are only TEXT (the typing hero
                   title, clocks, counters) no longer run the whole pass every
                   150ms; they fold into one pass at most every 2 seconds.
                   Anything that adds an ELEMENT runs it exactly as before. */
                var sawText = false;
                for (var i = 0; i < recs.length; i++) {
                    var r = recs[i];
                    if (r.type !== 'childList' || !r.addedNodes.length) continue;
                    var ours = true, textOnly = true;
                    for (var n = 0; n < r.addedNodes.length; n++) {
                        var node = r.addedNodes[n];
                        if (node.nodeType === 1) textOnly = false;
                        var cls = (node.className && node.className.baseVal !== undefined)
                                    ? node.className.baseVal
                                    : (typeof node.className === 'string' ? node.className : '');
                        if (node.nodeType !== 1 || cls.indexOf('mv-') !== 0) ours = false;
                    }
                    if (ours) continue;
                    if (textOnly) { sawText = true; continue; }
                    /* MV115 CLS — the sort bar and the image options are put in
                       in the SAME frame the Deals List appears (observer
                       callbacks run before paint), so the list no longer jumps
                       down ~150px a moment after it is drawn. */
                    /* MV119: asked every time, not only while NO sort bar exists
                       anywhere. The page has two lists that can each carry one
                       (the Deals List on the left and the list in the right-hand
                       panel); once the first had its bar, the second only got
                       its bar from the 150 ms refresh — after the browser had
                       already painted it, so the list jumped ~175 px (the
                       layout shift in the report). injectFilters() is
                       self-guarding: a host that has its bar returns at once. */
                    try { injectFilters(); } catch (e) {}
                    refresh();
                    return;
                }
                if (sawText) refreshSlow();
            }).observe(document.body, { childList: true, subtree: true });
        }
        watchDirection();

        if (window.console && console.info) {
            var cssOk = dealsCssLoaded();
            console.info('[mavely-deals] v32 ready'
                + (cssOk ? '' : ' — mavely-deals.v25.css did NOT load; badges are styled inline as a fallback'));
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }

    /* Description -> deal. The image layer needs this to recognise text that is
       being copied, so it can append the price line. Exposed rather than
       duplicated: this map is already built and kept fresh here. */
    window.MavelyDealsIndex = function (head) {
        head = String(head || '').trim();
        if (head.length < 8) return null;
        for (var k in dealsByImage) {
            if (!Object.prototype.hasOwnProperty.call(dealsByImage, k)) continue;
            var d = dealsByImage[k];
            var desc = String((d && d.description) || '').trim();
            if (!desc) continue;
            var first = desc.split('\n')[0].trim();
            if (!first) continue;
            if (head === first || head.indexOf(first) === 0 || first.indexOf(head) === 0) return d;
        }
        return null;
    };

    /* ---------------------------------------------------------------------
       ITEM 3 — watermark controls inside Blogger Configuration
       ---------------------------------------------------------------------
       Appended to the bottom of the configuration panel, found by one of its
       own field labels. appendChild only, as everywhere else, so React's own
       fields are never moved or wrapped.
       --------------------------------------------------------------------- */

    /* ---------------------------------------------------------------------
       ITEM 4 — hide tabs from the home page
       ---------------------------------------------------------------------
       Each tab button is tagged by its own label, then hidden with CSS keyed on
       a body class. Nothing is removed from the DOM, so React keeps managing
       its four buttons exactly as before and unticking a box brings the tab
       straight back with no reload.
       --------------------------------------------------------------------- */

    var TABS = [
        { id: 'timer',  label: 'Timer USA',          match: ['TIMER USA', 'أفضل أوقات النشر — ساعات أمريكا', 'ساعات أمريكا', 'HORARIO EE. UU.', 'HEURES USA'] },
        { id: 'deals',  label: 'Deals List',         match: ['DEALS LIST', 'قائمة العروض', 'LISTA DE OFERTAS', 'LISTE DES OFFRES'] },
        { id: 'manual', label: 'Manual Deals',       match: ['MANUAL DEAL LIST', 'MANUAL DEALS LIST', 'قائمة العروض اليدوية', 'OFERTAS MANUALES', 'OFFRES MANUELLES'] },
        { id: 'leads',  label: 'Network Live Leads', match: ['NETWORK LIVE LEADS', 'عملاء الشبكة المباشرون', 'CLIENTES EN VIVO', 'PROSPECTS EN DIRECT'] },
        /* v27 — the Group Score tab from assets/mavely-groupcalc.v1.js. It is
           not one of React's four buttons; that script inserts it and tags it
           data-mv-tab="group" itself, so applyTabVisibility() finds it with the
           others and the checkbox below is built from this list automatically.
           Listed last so the four original checkboxes keep their order, and
           matched by text as well in case the tag has not been applied yet. */
        { id: 'group',  label: 'Group Score',
          match: ['GROUP SCORE', 'تقييم المجموعة', 'PUNTUACIÓN', 'SCORE GROUPE'] }
    ];

    /**
     * A button's text as it would read in English.
     *
     * Checks the element and its children for data-mv-en, which mavely-i18n
     * sets when it translates a node. Falls back to the visible text, so this
     * works identically whether or not the translation layer is loaded.
     */
    function englishTextOf(node) {
        try {
            var own = node.getAttribute && node.getAttribute('data-mv-en');
            if (own) return own.replace(/\s+/g, ' ').trim().toUpperCase();
            var marked = node.querySelector && node.querySelector('[data-mv-en]');
            if (marked) {
                var v = marked.getAttribute('data-mv-en');
                if (v) return v.replace(/\s+/g, ' ').trim().toUpperCase();
            }
        } catch (e) {}
        return (node.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
    }

    function tabHidden(id) {
        try { return localStorage.getItem('mv_tab_hide_' + id) === '1'; } catch (e) { return false; }
    }

    /** Tag the four tab buttons and apply the body classes. */
    function applyTabVisibility() {
        var buttons = document.querySelectorAll('button');
        var strip = null;

        for (var i = 0; i < buttons.length; i++) {
            /* v28 — read data-mv-en FIRST.
               mavely-i18n records the original English on any element whose
               text it translated. Without this, switching to Spanish renamed
               "NETWORK LIVE LEADS" to "CLIENTES EN VIVO", no button matched,
               data-mv-tab was never applied, and both the hide-tabs checkboxes
               and the Group Score tab stopped working. */
            var t = englishTextOf(buttons[i]);
            if (!t || t.length > 40) continue;
            for (var k = 0; k < TABS.length; k++) {
                if (TABS[k].match.indexOf(t) === -1) continue;
                // only the tab STRIP, not a panel heading that reads the same
                var row = buttons[i].parentElement;
                if (!row || row.querySelectorAll('button').length < 3) continue;
                if (buttons[i].getAttribute('data-mv-tab') !== TABS[k].id) {
                    buttons[i].setAttribute('data-mv-tab', TABS[k].id);
                }
                strip = row;
                break;
            }
        }
        if (!strip) return false;
        strip.classList.add('mv-tabstrip');

        /* v7 hid the tab BUTTONS and nothing else, which is why hiding all four
           left the Deals List panel sitting there on its own: the panel is
           rendered from the active-tab state, not from the button.

           So the widget root — the element holding the strip AND the panel — is
           tagged here too. Hiding every tab now hides the whole thing. */
        var widget = strip;
        for (var w = 0; w < 6 && widget.parentElement; w++) {
            widget = widget.parentElement;
            if (widget.children.length >= 2) break;
        }
        if (widget && widget !== document.body) {
            widget.setAttribute('data-mv-tabwidget', '1');
        }

        var anyHidden = false, allHidden = true;
        TABS.forEach(function (tab) {
            var hide = tabHidden(tab.id);
            if (hide) anyHidden = true; else allHidden = false;
            document.body.classList[hide ? 'add' : 'remove']('mv-hide-' + tab.id);
        });
        document.body.classList[anyHidden ? 'add' : 'remove']('mv-tabs-trimmed');
        document.body.classList[allHidden ? 'add' : 'remove']('mv-tabs-all-hidden');
        return true;
    }

    /* Called only when the checkboxes CHANGE, never on the periodic pass —
       clicking a tab on every pass would fight you every time you switched. */
    function ensureVisibleTabSelected() {
        var strip = document.querySelector('.mv-tabstrip');
        if (!strip) return;

        var buttons = strip.querySelectorAll('[data-mv-tab]');
        var firstVisible = null;
        for (var i = 0; i < buttons.length; i++) {
            if (!tabHidden(buttons[i].getAttribute('data-mv-tab'))) { firstVisible = buttons[i]; break; }
        }
        if (!firstVisible) return;              // all hidden: the widget is gone anyway

        /* Rather than trying to work out which button React considers active —
           the styling differs per theme and is not reliable — the first visible
           tab is simply selected whenever the hidden set changes. That
           guarantees the panel on screen belongs to a tab you can still see. */
        for (var b = 0; b < buttons.length; b++) {
            if (tabHidden(buttons[b].getAttribute('data-mv-tab'))) {
                firstVisible.click();
                return;
            }
        }
    }

    function injectTabControls(host) {
        if (host.querySelector('.mv-tabcfg')) return;

        var box = el('div', 'mv-tabcfg');
        box.appendChild(el('div', 'mv-wmcfg-h', 'HIDE TABS ON THE HOME PAGE'));

        TABS.forEach(function (tab) {
            var row = el('label', 'mv-wmcfg-row');
            var chk = el('input');
            chk.type = 'checkbox';
            chk.checked = tabHidden(tab.id);
            chk.addEventListener('change', function () {
                try { localStorage.setItem('mv_tab_hide_' + tab.id, chk.checked ? '1' : '0'); } catch (e) {}
                applyTabVisibility();
                ensureVisibleTabSelected();
            });
            row.appendChild(chk);
            row.appendChild(el('span', null, 'Hide ' + tab.label));
            box.appendChild(row);
        });
        box.appendChild(el('div', 'mv-wmcfg-note',
            'Ticked tabs are hidden from the home page. Nothing is deleted — untick to bring one back.'));

        host.appendChild(box);
        injectImageOptionHiding(host);
    }

    /* ITEM 4 — hide the three image buttons themselves, for when they are set
       the way you want them and are only taking up room. Hiding one does NOT
       turn its feature off; it stays exactly as you last set it. */
    function imgOptHidden(key) {
        try { return localStorage.getItem('mv_opt_hide_' + key) === '1'; } catch (e) { return false; }
    }

    function applyImageOptionHiding() {
        IMG_OPTS.forEach(function (o) {
            document.body.classList[imgOptHidden(o.key) ? 'add' : 'remove']('mv-hideopt-' + o.key);
        });
    }

    function injectImageOptionHiding(host) {
        if (host.querySelector('.mv-optcfg')) return;

        var box = el('div', 'mv-optcfg');
        box.appendChild(el('div', 'mv-wmcfg-h', 'HIDE IMAGE OPTIONS'));

        IMG_OPTS.forEach(function (o) {
            var row = el('label', 'mv-wmcfg-row');
            var chk = el('input');
            chk.type = 'checkbox';
            chk.checked = imgOptHidden(o.key);
            chk.addEventListener('change', function () {
                try { localStorage.setItem('mv_opt_hide_' + o.key, chk.checked ? '1' : '0'); } catch (e) {}
                applyImageOptionHiding();
            });
            row.appendChild(chk);
            row.appendChild(el('span', null, 'Hide ' + o.label.replace(/\b\w+/g, function (m) {
                return m.charAt(0) + m.slice(1).toLowerCase();
            })));
            box.appendChild(row);
        });
        box.appendChild(el('div', 'mv-wmcfg-note',
            'Hiding a button does not switch its feature off — it stays as you last set it.'));

        host.appendChild(box);
    }

    /**
     * The scrolling body of the Blogger Configuration modal.
     *
     * Anchored on a label that only exists in that panel, then climbed until a
     * scrolling ancestor is found. Pulled out of injectWatermarkControls() so
     * the "admin2 owns the watermark" branch can still place the tab controls.
     */
    /* MV115 PERF — same answer, found without reading textContent of every
       div/span/label/p on the page on every pass (each read walks the whole
       subtree below it). The label's own TEXT NODE is found first, then the
       outermost label/div/span/p whose whole text is that label — which is
       exactly the element the old scan returned — then the same climb. */
    function findConfigPanelHost() {
        var root = document.body || document.documentElement, hit = null, tn, w;
        try { w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null); } catch (e) { w = null; }
        if (!w) return null;
        while ((tn = w.nextNode())) {
            var v = tn.nodeValue;
            if (!v || v.length > 40) continue;
            var t = v.replace(/\s+/g, ' ').trim().toUpperCase();
            if (t === 'BRAND NAME' || t === 'COLOR PALETTE') { hit = tn.parentElement; break; }
        }
        if (!hit) return null;
        var n = hit, best = null;
        for (var k = 0; k < 10 && n && n !== document.body; k++) {
            var tx = (n.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
            if (tx !== 'BRAND NAME' && tx !== 'COLOR PALETTE') break;
            if (/^(LABEL|DIV|SPAN|P)$/.test(n.tagName)) best = n;
            n = n.parentElement;
        }
        if (!best) return null;
        n = best;
        for (var g = 0; g < 6 && n.parentElement; g++) {
            n = n.parentElement;
            if (n.scrollHeight > n.clientHeight + 40) break;
        }
        return n;
    }

    /* -----------------------------------------------------------------------
       THE WATERMARK PANEL MOVED
       -----------------------------------------------------------------------
       This file used to build its own IMAGE WATERMARK box: a checkbox reading
       "Show https://mavelylink.com on copied images" — with the link hardcoded
       into the label, so there was no way to change it — plus an opacity
       slider. Both settings were stored in localStorage, which meant they
       applied to one browser on one device.

       mavely-admin2 builds a full editor for the same feature: on/off, the link
       as an editable field, a logo upload, opacity, size and position, all
       saved on the SERVER so they apply everywhere.

       The two used to collide. Both boxes carried the class .mv-wmcfg, and both
       used that class as their "have I already run?" test, so whichever ran
       first silenced the other. In practice this file won, which is why the old
       fixed-label version is the one that was on screen and the editor never
       appeared.

       So this file now stands aside when admin2 is present. It is not deleted:
       if mavely-admin2 is ever missing or fails to load, the block below still
       runs and you keep the on/off switch and the opacity slider exactly as
       they are today. The label is read from the live settings rather than
       hardcoded, so even the fallback shows the right link.
       ----------------------------------------------------------------------- */
    function injectWatermarkControls() {
        if (!window.MavelyImg) return false;

        /* Ownership is checked FIRST, before the "does a panel already exist"
           test below. admin2's section carries .mv-wmcfg too, so once it has
           rendered the old test would return early and the HIDE TABS controls
           would never be added on any later tick. Order matters here. */
        if (window.__MV_WM_PANEL_OWNER__ === 'admin2') {
            var hostForTabs = findConfigPanelHost();
            if (!hostForTabs) return false;
            injectTabControls(hostForTabs);      // has its own dedup guard
            return true;
        }

        if (document.querySelector('.mv-wmcfg')) return true;

        var host = findConfigPanelHost();
        if (!host) return false;

        var box = el('div', 'mv-wmcfg');
        box.appendChild(el('div', 'mv-wmcfg-h', 'IMAGE WATERMARK'));

        var row = el('label', 'mv-wmcfg-row');
        var chk = el('input'); chk.type = 'checkbox'; chk.checked = window.MavelyImg.wmEnabled();
        row.appendChild(chk);
        /* The label used to name the link in fixed text, which went stale the
           moment anybody changed it. Read it from the renderer instead. */
        var wmLabel = 'Show a watermark on copied images';
        try {
            var st = window.MavelyImg.wmSettings ? window.MavelyImg.wmSettings() : null;
            if (st && st.logoUrl)      wmLabel = 'Show your logo on copied images';
            else if (st && st.text)    wmLabel = 'Show ' + st.text + ' on copied images';
        } catch (e) {}
        row.appendChild(el('span', null, wmLabel));
        box.appendChild(row);

        var orow = el('div', 'mv-wmcfg-row');
        orow.appendChild(el('span', 'mv-wmcfg-lab', 'Opacity'));
        var rng = el('input');
        rng.type = 'range'; rng.min = '5'; rng.max = '100'; rng.step = '5';
        rng.value = String(Math.round(window.MavelyImg.wmOpacity() * 100));
        var out = el('span', 'mv-wmcfg-val', rng.value + '%');
        orow.appendChild(rng); orow.appendChild(out);
        box.appendChild(orow);
        box.appendChild(el('div', 'mv-wmcfg-note',
            'Applies when Add Logo to Image or Add Price to Image is on.'));

        chk.addEventListener('change', function () { window.MavelyImg.setWm(chk.checked, null); });
        rng.addEventListener('input', function () {
            out.textContent = rng.value + '%';
            window.MavelyImg.setWm(null, parseInt(rng.value, 10) / 100);
        });

        host.appendChild(box);
        injectTabControls(host);
        return true;
    }

    window.MavelyDeals = {
        sort: setSort,
        addPrice: function (on) {
            try { localStorage.setItem(PRICE_KEY, on ? '1' : '0'); } catch (e) {}
            var b = document.querySelector('.mv-addprice input');
            if (b) b.checked = !!on;
        },
        reload: function () { fetchedAt = 0; loadDeals(); }
    };
})();
